import axios from 'axios';

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem('verse_token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && window.location.pathname !== '/vc') {
      localStorage.removeItem('verse_token');
      window.location.href = '/';
    }
    return Promise.reject(err);
  }
);

export const extractErr = (err, fallback = 'Something went wrong.') => {
  const d = err?.response?.data;
  if (!d) return fallback;
  if (typeof d === 'string') return /^\s*</.test(d) ? fallback : d.slice(0, 300);  // proxy/HTML error pages never reach a toast
  if (d.detail) return typeof d.detail === 'string' ? d.detail : (d.detail.message || JSON.stringify(d.detail));
  return fallback;
};
